export default __webpack_public_path__ + "static/media/intimation-of-newspaper-advertisement.410c1072.pdf";